import {
  selectAlertBannerData,
  selectDispatchRibbonData,
  selectKpiGridData,
  selectRouteHeaderData,
  selectSuspendedPanelData,
} from "../utils/resultsChromeData.js";
import { selectSupportPanelsData } from "../utils/routeModelsData.js";
import { buildPlanningOptimizeConfirmationContent } from "../utils/resultsWorkspaceData.js";

export default function useResultsPageChromeModels({
  assignment = null,
  includeSuspendedDeliveriesInOptimization = false,
  mapRenderMeta = null,
  state = null,
  trip = null,
}) {
  void mapRenderMeta;

  const supportPanelsModel = selectSupportPanelsData(state, assignment, trip);

  return {
    alertBannerModel: selectAlertBannerData(state),
    dispatchRibbonModel: selectDispatchRibbonData(state, {
      buildPlanningOptimizeConfirmationContent,
      includeSuspendedDeliveriesInOptimization,
    }),
    kpiGridModel: selectKpiGridData(assignment, trip, supportPanelsModel.routeSequence),
    routeHeaderModel: selectRouteHeaderData(assignment, trip),
    supportPanelsModel,
    suspendedPanelModel: selectSuspendedPanelData(state, {
      includeSuspendedDeliveriesInOptimization,
    }),
  };
}
